import type { SourceAppViewType } from '@shared/constants/constants';
import type { GetAppointmentListPayload } from '@shared/services/appointment/getLists/types/getAppointmentList.type';

export const FormType = {
  Cervical: 'Cervical',
  General: 'General',
  Mammogram: 'Mammogram',
  Colorectal: 'Colorectal',
} as const;

export interface FormTypeLocation {
  appointmentType: string;
  formType: FormTypeType;
}

export type FormTypeType = (typeof FormType)[keyof typeof FormType];

export const CancelReasonType = {
  reasonNoCompany: 'No one is able to accompany me',
  reasonOthers: 'Others',
  reasonScheduleConflict: 'Schedule conflicts with my work/family commitments',
  reasonTreatmentElsewhere: 'I am seeking treatment elsewhere',
  reasonWell: 'I am well already',
} as const;

export const QuestionType = {
  Boolean: 'Boolean',
  CheckBox: 'CheckBox',
  Choice: 'Choice',
  Date: 'Date',
  DateInput: 'DateInput',
  Decimal: 'Decimal',
  Display: 'Display',
  Dropdown: 'Dropdown',
  Group: 'Group',
  Integer: 'Integer',
  OpenChoice: 'open-choice',
  PostalCode: 'postalCode',
  Select: 'Select',
  String: 'String',
  Text: 'Text',
  TextArea: 'TextArea',
} as const;

export interface FormSubmissionPayload extends GetAppointmentListPayload {
  AppointmentType?: string;
  ContactNumber?: string;
  CustomSourceApp?: SourceAppViewType;
  EmailAddress?: string;
  Files?: {
    Data: string;
    FileName: string;
    FileType: string;
  }[];
  InstitutionCode?: string;
  JsonValue?: string;
  PatientName?: string;
  RequestFormType?: string;
}

export interface FormSubmissionResult {
  IsSuccess: boolean;
}

export type QuestionTypeType = (typeof QuestionType)[keyof typeof QuestionType];
